// extracted by mini-css-extract-plugin
module.exports = {"link":"AYLink_link__24R7t"};